import React, { useEffect, useRef } from 'react';
import { useTheme } from '../../theme-context';


interface ITableActions {
    children?: React.ReactNode;
    containerStyle?: string;
    iconStyle?: string;
}

const TableActions = ({
    children,
    containerStyle,
    iconStyle,
}: ITableActions) => {
    const { theme } = useTheme();
    const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
    const dropdownMenu = useRef<any>(null);

    const closeDropdownPopover = (e: any) => {
        if (dropdownMenu?.current && !dropdownMenu?.current?.contains(e.target)) {
            setDropdownPopoverShow(false);
        }
    }

    useEffect(() => {
        document.addEventListener('click', closeDropdownPopover, true);
        return () => {
            document.removeEventListener('click', closeDropdownPopover, true);
        };
    }, []);

    return (
        <div>
            <div>
                <button
                    onClick={(e) => setDropdownPopoverShow(!dropdownPopoverShow)}
                    type='button'
                    data-qa={'actions'}
                    className={''} 
                    id='menu-button' 
                    aria-expanded='true' 
                    aria-haspopup='true'>
                    <img title={'Action'} alt='items arrow' src={theme === 'dark' ? '/assets/insights/see-more-icon-white.svg' : '/assets/insights/see-more-icon.svg'} className={`h-8 object-contain cursor-pointer mr-2 ${iconStyle}`} />
                </button>
            </div>
            <div
                ref={dropdownMenu}
                className={`${dropdownPopoverShow ? '' : 'hidden'} shadow-xl max-h-[150px] overflow-auto absolute right-0 z-10 mt-0 w-45 origin-top-right divide-y divide-[#a4a4a4] bg-white focus:outline-none ${containerStyle}`}
                role='menu'
                aria-orientation='vertical'
                aria-labelledby='menu-button'
                tabIndex={-1}>
                {children}
            </div>
        </div>
    )
}

export default TableActions;